import { z } from 'zod';

import {
    createDeleteSchema,
    createUpdateSchemaFromAdd,
    requiredNumber,
    requiredString,
    requiredUuid,
} from './fields';
import { SYNC_UPDATE_VALIDATION_SCHEMA } from './common';

export const createLocationsAddSchema = () =>
    z.object({
        id: requiredUuid(),
        created_at: requiredNumber(),
        updated_at: requiredNumber(),
        place_id: requiredString(),
        name: requiredString(),
        lat: requiredString(),
        lng: requiredString(),
        url: requiredString(),
        utc_offset: requiredNumber(),
        user_id: requiredUuid(),
        organisation_id: requiredUuid(),
    });

export const createLocationsUpdateSchema = () =>
    createUpdateSchemaFromAdd(
        createLocationsAddSchema(),
        SYNC_UPDATE_VALIDATION_SCHEMA.locations,
    );

export const createLocationsDeleteSchema = () => createDeleteSchema();

export const createLocationsSchemas = () => ({
    add: createLocationsAddSchema(),
    update: createLocationsUpdateSchema(),
    delete: createLocationsDeleteSchema(),
});
